import { AppBar, Toolbar } from '@mui/material';

import { Button } from '@/components/ui/button';

interface Props {
  actionsDisabled: boolean;
  onUserCancel: () => void;
  publishDisabled: boolean;
  campaignId?: number;
  onDelete?: () => void;
  onEndNow?: () => void;
  onSchedule?: () => void;
}

export default function EditPromotionNavBar({
  actionsDisabled,
  onUserCancel,
  publishDisabled,
  campaignId,
  onDelete,
  onEndNow,
  onSchedule,
}: Props) {
  return (
    <AppBar
      data-testid="edit-promotion-nav-bar"
      position="fixed"
      color="inherit"
      elevation={1}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        padding: '0px 10%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        boxShadow: 'none',
        borderTop: (theme) => `1px solid ${theme.palette.secondary.light}`,
        top: 'auto',
        bottom: 0,
      }}
    >
      <Toolbar
        sx={{
          padding: 0,
          '&.MuiToolbar-root': {
            paddingLeft: 0,
            paddingRight: 0,
          },
        }}
      >
        <fieldset
          className="flex h-7 w-full items-center justify-between gap-4"
          disabled={actionsDisabled}
        >
          <Button onClick={onUserCancel} type="button" variant="outline">
            Cancel
          </Button>
          <div className="flex items-center gap-2">
            {campaignId && onDelete && (
              <Button onClick={onDelete} type="button" variant="destructive">
                Delete
              </Button>
            )}
            {campaignId && onEndNow && (
              <Button onClick={onEndNow} type="button" variant="destructive">
                End Now
              </Button>
            )}
            <Button
              disabled={publishDisabled}
              onClick={onSchedule}
              type="button"
            >
              {campaignId ? 'Save' : 'Schedule'}
            </Button>
          </div>
        </fieldset>
      </Toolbar>
    </AppBar>
  );
}
